export default __webpack_public_path__ + "static/media/error.2afe1b6b.gif";